// authActions.js
export const SET_GINNE_LOGIN = 'SET_GINNE_LOGIN';

// Action to set the isGinneLogin flag
export const setGinneLogin = (value) => {
  return {
    type: SET_GINNE_LOGIN,
    payload: value,
  };
};
